import script from "./acme.cert-manager.io.challenge.vue?vue&type=script&setup=true&lang=ts"
export * from "./acme.cert-manager.io.challenge.vue?vue&type=script&setup=true&lang=ts"

import "./acme.cert-manager.io.challenge.vue?vue&type=style&index=0&id=76ede9d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ede9d6"]])

export default __exports__